import { UIText2 } from '@cian/ui-kit';
import { Button } from '@cian/ui-kit/button';
import * as React from 'react';

import * as styles from './ErrorContent.css';

interface IErrorContentProps {
  text?: string;
  onRetry(): void;
}

export const ErrorContent: React.FC<IErrorContentProps> = ({ text, onRetry }) => {
  return (
    <div data-testid="error-content" className={styles['container']}>
      <UIText2>
        {text ||
          'Во время загрузки произошла ошибка. Пожалуйста, проверьте своё интернет соединение и попробуйте ещё раз.'}
      </UIText2>
      <Button onClick={onRetry}>Повторить</Button>
    </div>
  );
};
